module.exports = __webpack_public_path__ + "assets/img/throwbag-allround.832f4d76.png";